import { Injectable } from '@angular/core';
import { ResourceService } from 'sce-core';

@Injectable()
export class ViewbalanceService {

  private columnDataMap = {
    'LotBalance': [{
      prop: 'lot',
      name: this.getLabel('lot'),
      sortOrder: -1,
      type: 'string'
    }, {
      prop: 'qty',
      name: this.getLabel('qty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyPreallocated',
      name: this.getLabel('qtyPreallocated'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyAllocated',
      name: this.getLabel('qtyAllocated'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyPicked',
      name: this.getLabel('qtyPicked'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'casecnt',
      name: this.getLabel('casecnt'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'innerPack',
      name: this.getLabel('innerPack'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'pallet',
      name: this.getLabel('pallet'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'cube',
      name: this.getLabel('cube'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'grossWgt',
      name: this.getLabel('grossWgt'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'netWgt',
      name: this.getLabel('netWgt'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'otherUnit1',
      name: this.getLabel('otherUnit1'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'otherUnit2',
      name: this.getLabel('otherUnit2'),
      sortOrder: -1,
      type: 'number'
    }],
    'LotLocMovableUnit': [{
      prop: 'lot',
      name: this.getLabel('lot'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'loc',
      name: this.getLabel('loc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'id',
      name: this.getLabel('id'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qty',
      name: this.getLabel('qty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyAllocated',
      name: this.getLabel('qtyAllocated'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyPicked',
      name: this.getLabel('qtyPicked'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyExpected',
      name: this.getLabel('qtyExpected'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyPickInProgress',
      name: this.getLabel('qtyPickInProgress'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable01',
      name: this.getLabel('lottable01'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable02',
      name: this.getLabel('lottable02'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable03',
      name: this.getLabel('lottable03'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable04',
      name: this.getLabel('lottable04'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable05',
      name: this.getLabel('lottable05'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable06',
      name: this.getLabel('lottable06'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable07',
      name: this.getLabel('lottable07'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable08',
      name: this.getLabel('lottable08'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable09',
      name: this.getLabel('lottable09'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable10',
      name: this.getLabel('lottable10'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable11',
      name: this.getLabel('lottable11'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable12',
      name: this.getLabel('lottable12'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable13',
      name: this.getLabel('lottable13'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable14',
      name: this.getLabel('lottable14'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable15',
      name: this.getLabel('lottable15'),
      sortOrder: -1,
      type: 'number'
    }],
    'CommodityLoc': [{
      prop: 'locationType',
      name: this.getLabel('locationType'),
      sortOrder: -1,
      type: 'string'
    }, {
      prop: 'loc',
      name: this.getLabel('loc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyLocationLimit',
      name: this.getLabel('qtyLocationLimit'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyLocationMinimum',
      name: this.getLabel('qtyLocationMinimum'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qty',
      name: this.getLabel('qty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyAllocated',
      name: this.getLabel('qtyAllocated'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qyPicked',
      name: this.getLabel('qyPicked'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyExpected',
      name: this.getLabel('qtyExpected'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qtyPickInProcess',
      name: this.getLabel('qtyPickInProcess'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'replenishmentPriority',
      name: this.getLabel('replenishmentPriority'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'replenishmentSeverity',
      name: this.getLabel('replenishmentSeverity'),
      sortOrder: -1,
      type: 'number'
    }],
    'InventoryTransaction': [{
      prop: 'addDate',
      name: this.getLabel('addDate'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'tranType',
      name: this.getLabel('tranType'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sourceKey',
      name: this.getLabel('sourceKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sourceType',
      name: this.getLabel('sourceType'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'storerKey',
      name: this.getLabel('storerKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sku',
      name: this.getLabel('sku'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuDescr',
      name: this.getLabel('skuDescr'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuStyle',
      name: this.getLabel('skuStyle'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuColor',
      name: this.getLabel('skuColor'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuSize',
      name: this.getLabel('skuSize'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuMeasurement',
      name: this.getLabel('skuMeasurement'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromLocFacility',
      name: this.getLabel('fromLocFacility'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromLoc',
      name: this.getLabel('fromLoc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromID',
      name: this.getLabel('fromID'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toLocFacility',
      name: this.getLabel('toLocFacility'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toLoc',
      name: this.getLabel('toLoc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toID',
      name: this.getLabel('toID'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qty',
      name: this.getLabel('qty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable01',
      name: this.getLabel('lottable01'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable02',
      name: this.getLabel('lottable02'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable03',
      name: this.getLabel('lottable03'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable04',
      name: this.getLabel('lottable04'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable05',
      name: this.getLabel('lottable05'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable06',
      name: this.getLabel('lottable06'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable07',
      name: this.getLabel('lottable07'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable08',
      name: this.getLabel('lottable08'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable09',
      name: this.getLabel('lottable09'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable10',
      name: this.getLabel('lottable10'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable11',
      name: this.getLabel('lottable11'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable12',
      name: this.getLabel('lottable12'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable13',
      name: this.getLabel('lottable13'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable14',
      name: this.getLabel('lottable14'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable15',
      name: this.getLabel('lottable15'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lot',
      name: this.getLabel('lot'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'packKey',
      name: this.getLabel('packKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'uomQty',
      name: this.getLabel('uomQty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'addWho',
      name: this.getLabel('addWho'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'editDate',
      name: this.getLabel('editDate'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'editwho',
      name: this.getLabel('editwho'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'itrnKey',
      name: this.getLabel('itrnKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'status',
      name: this.getLabel('status'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'uom',
      name: this.getLabel('uom'),
      sortOrder: -1,
      type: 'number'
    }],
    'ShowTransaction': [{
      prop: 'addDate',
      name: this.getLabel('addDate'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'tranType',
      name: this.getLabel('tranType'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sourceKey',
      name: this.getLabel('sourceKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sourceType',
      name: this.getLabel('sourceType'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'storerKey',
      name: this.getLabel('storerKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sku',
      name: this.getLabel('sku'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuDescr',
      name: this.getLabel('skuDescr'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuStyle',
      name: this.getLabel('skuStyle'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuColor',
      name: this.getLabel('skuColor'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuSize',
      name: this.getLabel('skuSize'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuMeasurement',
      name: this.getLabel('skuMeasurement'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromLocFacility',
      name: this.getLabel('fromLocFacility'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromLoc',
      name: this.getLabel('fromLoc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromID',
      name: this.getLabel('fromID'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toLocFacility',
      name: this.getLabel('toLocFacility'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toLoc',
      name: this.getLabel('toLoc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toID',
      name: this.getLabel('toID'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qty',
      name: this.getLabel('qty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable01',
      name: this.getLabel('lottable01'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable02',
      name: this.getLabel('lottable02'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable03',
      name: this.getLabel('lottable03'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable04',
      name: this.getLabel('lottable04'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable05',
      name: this.getLabel('lottable05'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable06',
      name: this.getLabel('lottable06'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable07',
      name: this.getLabel('lottable07'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable08',
      name: this.getLabel('lottable08'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable09',
      name: this.getLabel('lottable09'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable10',
      name: this.getLabel('lottable10'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable11',
      name: this.getLabel('lottable11'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable12',
      name: this.getLabel('lottable12'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable13',
      name: this.getLabel('lottable13'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable14',
      name: this.getLabel('lottable14'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable15',
      name: this.getLabel('lottable15'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lot',
      name: this.getLabel('lot'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'packKey',
      name: this.getLabel('packKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'uomQty',
      name: this.getLabel('uomQty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'addWho',
      name: this.getLabel('addWho'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'editDate',
      name: this.getLabel('editDate'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'editwho',
      name: this.getLabel('editwho'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'itrnKey',
      name: this.getLabel('itrnKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'status',
      name: this.getLabel('status'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'uom',
      name: this.getLabel('uom'),
      sortOrder: -1,
      type: 'number'
    }],
    'InventoryLineTransaction': [{
      prop: 'addDate',
      name: this.getLabel('addDate'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'tranType',
      name: this.getLabel('tranType'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sourceKey',
      name: this.getLabel('sourceKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sourceType',
      name: this.getLabel('sourceType'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'storerKey',
      name: this.getLabel('storerKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'sku',
      name: this.getLabel('sku'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuDescr',
      name: this.getLabel('skuDescr'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuStyle',
      name: this.getLabel('skuStyle'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuColor',
      name: this.getLabel('skuColor'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuSize',
      name: this.getLabel('skuSize'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'skuMeasurement',
      name: this.getLabel('skuMeasurement'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromLocFacility',
      name: this.getLabel('fromLocFacility'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromLoc',
      name: this.getLabel('fromLoc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'fromID',
      name: this.getLabel('fromID'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toLocFacility',
      name: this.getLabel('toLocFacility'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toLoc',
      name: this.getLabel('toLoc'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'toID',
      name: this.getLabel('toID'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'qty',
      name: this.getLabel('qty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable01',
      name: this.getLabel('lottable01'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable02',
      name: this.getLabel('lottable02'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable03',
      name: this.getLabel('lottable03'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable04',
      name: this.getLabel('lottable04'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable05',
      name: this.getLabel('lottable05'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable06',
      name: this.getLabel('lottable06'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable07',
      name: this.getLabel('lottable07'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable08',
      name: this.getLabel('lottable08'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable09',
      name: this.getLabel('lottable09'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable10',
      name: this.getLabel('lottable10'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable11',
      name: this.getLabel('lottable11'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable12',
      name: this.getLabel('lottable12'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable13',
      name: this.getLabel('lottable13'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable14',
      name: this.getLabel('lottable14'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lottable15',
      name: this.getLabel('lottable15'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'lot',
      name: this.getLabel('lot'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'packKey',
      name: this.getLabel('packKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'uomQty',
      name: this.getLabel('uomQty'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'addWho',
      name: this.getLabel('addWho'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'editDate',
      name: this.getLabel('editDate'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'editwho',
      name: this.getLabel('editwho'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'itrnKey',
      name: this.getLabel('itrnKey'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'status',
      name: this.getLabel('status'),
      sortOrder: -1,
      type: 'number'
    }, {
      prop: 'uom',
      name: this.getLabel('uom'),
      sortOrder: -1,
      type: 'number'
    }]


  };

  constructor(private resourceService: ResourceService) { }

  public getColumnDataForType(type: string) {
    return this.columnDataMap[type];
  }
// method used to translate the labels
public getLabel(key: any) {
  return this.resourceService.get(key);
}
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/viewbalance-lookup/viewbalance-lookup.service.ts